module.exports = __webpack_public_path__ + "img/logo-horizontal-transparent.b27c78dd.svg";